var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnSelectedPaymentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:payment-32-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.0625 5.03906C3.31658 5.03906 2.60121 5.33538 2.07376 5.86282C1.54632 6.39027 1.25 7.10564 1.25 7.85156V8.78906H18.75V7.85156C18.75 7.10564 18.4537 6.39027 17.9262 5.86282C17.3988 5.33538 16.6834 5.03906 15.9375 5.03906H4.0625ZM1.25 15.9766V10.0391H18.75V15.9766C18.75 16.7225 18.4537 17.4379 17.9262 17.9653C17.3988 18.4927 16.6834 18.7891 15.9375 18.7891H4.0625C3.31658 18.7891 2.60121 18.4927 2.07376 17.9653C1.54632 17.4379 1.25 16.7225 1.25 15.9766ZM13.125 13.7891C12.9592 13.7891 12.8003 13.8549 12.6831 13.9721C12.5658 14.0893 12.5 14.2483 12.5 14.4141C12.5 14.5798 12.5658 14.7388 12.6831 14.856C12.8003 14.9732 12.9592 15.0391 13.125 15.0391H15C15.1658 15.0391 15.3247 14.9732 15.4419 14.856C15.5592 14.7388 15.625 14.5798 15.625 14.4141C15.625 14.2483 15.5592 14.0893 15.4419 13.9721C15.3247 13.8549 15.1658 13.7891 15 13.7891H13.125Z",
    fill: "#9999CD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnSelectedPaymentIcon);
export default __webpack_public_path__ + "static/media/unSelectedPaymentIcon.ccf936d22e3b7d68f6d23937fda1c0ff.svg";
export { ForwardRef as ReactComponent };